<template>
  <button
    @click="activateItem(section)"
    :class="isActive ? 'border-1 shadow-lg text-blue-500' : 'border-0'"
    class="uppercase text-blue-700 flex gap-1 items-center border-b-0 p-3 w-full focus:outline-none"
  >
    <!--<fa:info-circle class="text-sm" />-->
    <p>{{ section.label }}</p>
  </button>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  name: 'TabHeader',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()
    function activateItem(item) {
      store.state.Details.activeSection = item
    }
    const isActive = computed(() => store.state.Details.activeSection === props.section)

    return { isActive, activateItem }
  },
}
</script>

<style scoped>

</style>
